import React from "react";
import { motion } from "framer-motion";
import "./Skills.css";

// Assign levels (example based on resume highlights)
const skills = [
  { name: "JavaScript / TypeScript", level: 95 },
  { name: "React / Next.js", level: 90 },
  { name: "Node.js / Express", level: 90 },
  { name: "Python / Flask", level: 85 },
  { name: "Go", level: 85 },
  { name: "Spring Boot / Java", level: 85 },
  { name: "Kubernetes / Docker", level: 90 },
  { name: "AWS / Cloud", level: 85 },
  { name: "PostgreSQL / MySQL", level: 90 },
  { name: "MongoDB / Redis / DynamoDB", level: 80 },
  { name: "Git / CI-CD", level: 95 },
  { name: "GraphQL", level: 75 },
  { name: "Swift / Flutter", level: 70 },
];

const Skills = () => {
  return (
    <section id="skills" className="skills-section">
      <h2 className="skills-title">My Skills</h2>
     <div className="skills-container">
        {skills.map((skill, index) => (
          <div key={index} className="skill-row">
            <div className="skill-label">{skill.name}</div>
            <div className="skill-bar">
              <motion.div
                className="skill-progress"
                initial={{ width: 0 }}
                whileInView={{ width: `${skill.level}%` }}
                transition={{ duration: 1, ease: "easeOut" }}
                viewport={{ once: true }}
              />
            </div>
            <span className="skill-percent">{skill.level}%</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
